import { useEffect } from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'

const CONSOLE_URL = 'https://app-bg.planesailing.io'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

const topLinks = [
  { label: 'Problems', href: '/problems' },
  { label: 'Features', href: '/features' },
  { label: 'Pricing', href: '/pricing' },
]

function Wordmark({ size }: { size?: string }) {
  return (
    <Link className="brand" style={size ? { fontSize: size } : undefined} to="/">
      <span className="brand-mark">BG</span>
      Break <span>Glass</span>
    </Link>
  )
}

export function AppShell() {
  return (
    <>
      <ScrollToTop />
      <div className="site-shell">
        <header className="topbar">
          <Wordmark />
          <nav className="topnav" aria-label="Primary">
            {topLinks.map((link) => (
              <NavLink
                key={link.label}
                className={({ isActive }) => `topnav-link${isActive ? ' is-active' : ''}`}
                to={link.href}
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <div className="topbar-actions">
            <a className="button button-solid" href={CONSOLE_URL}>
              Launch console
            </a>
          </div>
        </header>

        <main>
          <Outlet />
        </main>

        <footer className="footer">
          <div className="footer-grid">
            <div>
              <Wordmark size="1rem" />
              <p className="footer-copy">
                A ceremony orchestrator for your secrets. Shamir-split a data key across a quorum,
                prove possession over time, and reconstruct in the browser. No plaintext ever
                traverses a server.
              </p>
            </div>
            <div>
              <h4>Product</h4>
              <Link to="/problems">Problems it solves</Link>
              <Link to="/features">Features</Link>
              <Link to="/pricing">Pricing</Link>
            </div>
            <div>
              <h4>How it works</h4>
              <Link to="/#ceremony">The ceremony</Link>
              <Link to="/#peer-to-peer">Peer-to-peer</Link>
              <Link to="/#identity">Identity &amp; trust</Link>
            </div>
            <div>
              <h4>Get started</h4>
              <a href={CONSOLE_URL}>Launch console</a>
              <Link to="/pricing">Self-host (open source)</Link>
              <Link to="/features">Roadmap</Link>
            </div>
          </div>
        </footer>
      </div>
    </>
  )
}
